// extracted by mini-css-extract-plugin
module.exports = {"container":"betslipFooter__container___3_6TH","footer":"betslipFooter__footer___7npad","is-disabled":"betslipFooter__is-disabled___fidud"};